export const common = {
  // Header
  'header.home': 'Accueil',
  'header.about': 'À propos',
  'header.faq': 'FAQ',
  'header.contact': 'Contact',
  'header.signIn': 'Se connecter',
  'header.getStarted': 'Commencer',

  // Footer
  'footer.tagline': 'Élevez votre avenir financier',
  'footer.description': 'Solutions de paiement sécurisées, fiables et innovantes pour les particuliers et les entreprises du monde entier.',
  'footer.quickLinks': 'Liens rapides',
  'footer.services': 'Services',
  'footer.contact': 'Nous contacter',
  'footer.address': '789 Summit Avenue, San Francisco, CA 94102',
  'footer.email': 'support@pinnaclepayments.com',
  'footer.phone': '+1 (415) 555-1234',
  'footer.copyright': '© 2024 Pinnacle Payments. Tous droits réservés.',
  'footer.privacy': 'Politique de confidentialité',
  'footer.terms': 'Conditions d\'utilisation',

  // Home Page
  'home.hero.title': 'Élevez votre avenir financier',
  'home.hero.subtitle': 'Découvrez une banque fluide avec une technologie de pointe. Gérez votre patrimoine, investissez intelligemment et atteignez vos objectifs financiers avec Pinnacle Payments.',
  'home.hero.cta': 'Commencer aujourd\'hui',
  'home.hero.learn': 'En savoir plus',

  'home.stats.users': 'Utilisateurs actifs',
  'home.stats.countries': 'Pays desservis',
  'home.stats.transactions': 'Transactions traitées',
  'home.stats.support': 'Support 24/7',

  'home.services.title': 'Nos services premium',
  'home.services.subtitle': 'Solutions financières complètes adaptées à vos besoins',

  'home.services.banking.title': 'Banque numérique',
  'home.services.banking.desc': 'Banque moderne à portée de main avec virements instantanés, paiements de factures et suivi du solde en temps réel.',

  'home.services.investment.title': 'Solutions d\'investissement',
  'home.services.investment.desc': 'Faites fructifier votre patrimoine avec nos portefeuilles d\'investissement sélectionnés et nos conseils financiers d\'experts.',

  'home.services.loans.title': 'Prêts flexibles',
  'home.services.loans.desc': 'Prêts personnels et professionnels à approbation rapide avec des taux compétitifs et des conditions de remboursement flexibles.',

  'home.services.cards.title': 'Cartes virtuelles',
  'home.services.cards.desc': 'Cartes de débit et de crédit virtuelles sécurisées pour des achats en ligne et des transactions internationales en toute sécurité.',

  'home.features.title': 'Pourquoi choisir Pinnacle Payments',
  'home.features.subtitle': 'Découvrez l\'excellence bancaire avec des fonctionnalités de pointe',

  'home.features.security.title': 'Sécurité bancaire',
  'home.features.security.desc': 'Vos fonds sont protégés par un cryptage de niveau militaire et une authentification multifacteur.',

  'home.features.instant.title': 'Virements instantanés',
  'home.features.instant.desc': 'Envoyez et recevez de l\'argent instantanément dans plus de 180 pays sans délai.',

  'home.features.support.title': 'Support expert 24/7',
  'home.features.support.desc': 'Notre équipe dédiée est toujours disponible pour vous aider avec toutes vos questions ou préoccupations.',

  'home.features.rates.title': 'Taux compétitifs',
  'home.features.rates.desc': 'Profitez des meilleurs taux de change et des frais les plus bas du secteur pour toutes les transactions.',

  'home.plans.title': 'Plans de croissance financière',
  'home.plans.subtitle': 'Choisissez le plan parfait pour atteindre vos objectifs financiers',

  'home.plans.dps.title': 'Régime de pension de dépôt',
  'home.plans.dps.rate': 'Rendement annuel',
  'home.plans.dps.term': 'Conditions flexibles',
  'home.plans.dps.feature1': 'Options de dépôt mensuel',
  'home.plans.dps.feature2': 'Rendements garantis',
  'home.plans.dps.feature3': 'Avantages fiscaux',
  'home.plans.dps.feature4': 'Option de retrait anticipé',
  'home.plans.dps.cta': 'Commencer à épargner',

  'home.plans.fdr.title': 'Reçu de dépôt fixe',
  'home.plans.fdr.rate': 'Taux d\'intérêt',
  'home.plans.fdr.term': 'Période de blocage',
  'home.plans.fdr.feature1': 'Rendements élevés garantis',
  'home.plans.fdr.feature2': 'Options de durée flexibles',
  'home.plans.fdr.feature3': 'Prêt contre FDR',
  'home.plans.fdr.feature4': 'Renouvellement automatique disponible',
  'home.plans.fdr.cta': 'Investir maintenant',

  'home.plans.loan.title': 'Prêts personnels',
  'home.plans.loan.rate': 'À partir de',
  'home.plans.loan.term': 'Période de remboursement',
  'home.plans.loan.feature1': 'Approbation rapide en 24 heures',
  'home.plans.loan.feature2': 'Pas de frais cachés',
  'home.plans.loan.feature3': 'Options EMI flexibles',
  'home.plans.loan.feature4': 'Documentation minimale',
  'home.plans.loan.cta': 'Postuler maintenant',

  'home.testimonials.title': 'Ce que disent nos clients',
  'home.testimonials.subtitle': 'Rejoignez des milliers de clients satisfaits dans le monde entier',

  'home.cta.title': 'Prêt à transformer votre avenir financier?',
  'home.cta.subtitle': 'Rejoignez des millions d\'utilisateurs qui font confiance à Pinnacle Payments pour leurs besoins financiers',
  'home.cta.button': 'Créer votre compte',

  // About Page
  'about.hero.title': 'À propos de Pinnacle Payments',
  'about.hero.subtitle': 'Leader de l\'avenir de la finance numérique depuis 2010',

  'about.story.title': 'Notre histoire',
  'about.story.content': 'Fondée en 2010, Pinnacle Payments est née d\'une vision visant à révolutionner le secteur des services financiers. Nous avons reconnu que la banque traditionnelle ne répondait pas aux besoins d\'un monde numérique en évolution rapide. Nos fondateurs, une équipe de pionniers de la fintech et de vétérans de la banque, se sont lancés dans la création d\'une plateforme combinant technologie de pointe et service personnalisé. Aujourd\'hui, nous servons plus de 8 millions de clients dans 180 pays, traitant des milliards de transactions chaque année tout en maintenant notre engagement envers la sécurité, l\'innovation et la satisfaction client.',

  'about.mission.title': 'Notre mission',
  'about.mission.content': 'Donner aux particuliers et aux entreprises du monde entier des solutions financières accessibles, sécurisées et innovantes qui leur permettent d\'atteindre leurs objectifs et de bâtir une prospérité durable.',

  'about.vision.title': 'Notre vision',
  'about.vision.content': 'Devenir la plateforme financière numérique la plus fiable au monde, établissant de nouvelles normes d\'excellence, de sécurité et d\'expérience client dans le secteur de la fintech.',

  'about.stats.customers': 'Clients satisfaits',
  'about.stats.transactions': 'Transactions traitées',
  'about.stats.countries': 'Pays dans le monde',
  'about.stats.rating': 'Note client',

  'about.values.title': 'Nos valeurs fondamentales',
  'about.values.security.title': 'Sécurité d\'abord',
  'about.values.security.desc': 'Nous priorisons la sécurité de vos fonds et données avant tout.',
  'about.values.innovation.title': 'Innovation',
  'about.values.innovation.desc': 'Évolution continue pour fournir des solutions financières de pointe.',
  'about.values.transparency.title': 'Transparence',
  'about.values.transparency.desc': 'Communication claire et pratiques honnêtes dans tout ce que nous faisons.',
  'about.values.excellence.title': 'Excellence',
  'about.values.excellence.desc': 'Offrir un service et des résultats exceptionnels à nos clients.',

  'about.team.title': 'Rencontrez notre équipe de direction',
  'about.team.subtitle': 'Professionnels expérimentés stimulant l\'innovation dans la fintech',

  // FAQ Page
  'faq.title': 'Questions fréquemment posées',
  'faq.subtitle': 'Trouvez des réponses aux questions courantes sur nos services',

  'faq.general': 'Général',
  'faq.account': 'Compte',
  'faq.security': 'Sécurité',
  'faq.payments': 'Paiements',

  // Contact Page
  'contact.title': 'Contactez-nous',
  'contact.subtitle': 'Nous sommes là pour vous aider avec toutes vos questions ou préoccupations',

  'contact.info.title': 'Informations de contact',
  'contact.info.address': 'Visitez-nous',
  'contact.info.email': 'Envoyez-nous un e-mail',
  'contact.info.phone': 'Appelez-nous',
  'contact.info.hours': 'Heures d\'ouverture',
  'contact.info.hoursValue': 'Lundi - Vendredi: 8h00 - 19h00 PST',

  'contact.form.title': 'Envoyez-nous un message',
  'contact.form.name': 'Nom complet',
  'contact.form.email': 'Adresse e-mail',
  'contact.form.subject': 'Sujet',
  'contact.form.message': 'Message',
  'contact.form.send': 'Envoyer le message',

  'contact.map.title': 'Notre emplacement',
};

export default common;